module.exports = __webpack_public_path__ + "resources/img/img-zenius-apm-01.af13dbdda072793187fc00d12d553820.png";